/**
 * Spring Security's double-submit CSRF scheme: the server writes a readable `XSRF-TOKEN` cookie,
 * and every state-changing request must echo it back in the `X-XSRF-TOKEN` header.
 *
 * The cookie only appears once a request has passed through the backend's session filter chain —
 * `GET /api/me` on startup is what primes it (see `useSessionBootstrap`).
 */
const COOKIE_NAME = 'XSRF-TOKEN';
export const CSRF_HEADER = 'X-XSRF-TOKEN';

export function readCsrfToken(): string | undefined {
  // Cookie values are URL-encoded on the way out; Spring compares against the decoded token.
  const match = document.cookie.split('; ').find((c) => c.startsWith(`${COOKIE_NAME}=`));
  return match ? decodeURIComponent(match.slice(COOKIE_NAME.length + 1)) : undefined;
}
